
import React, { PureComponent } from 'react';
import InputClearifier from '../component/InputClarifier';
import Language from 'services/Language.js';
import utils from 'services/utils';
import { CodeSendHandlersIds } from 'constant/CodeSendHandlersIds';

/*
    HANDLER_SMS: 1,
    HANDLER_GOOGLE: 2,
    HANDLER_WORD: 3,
    HANDLER_EMAIL: 4,
    HANDLER_PASSWORD: 5,
    HANDLER_CAPTCHA: 6,
    HANDLER_CAPTCHA: 8
*/

const TIMER_TICK_TIMEOUT = 1000 / 60;
const funcStub = () => { };

class ModalTextForm extends PureComponent {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCloseKeyboard = this.handleCloseKeyboard.bind(this);
        this.handleKeyBoardOnClear = this.handleKeyBoardOnClear.bind(this);
        this.handleOpenKeyboard = this.handleOpenKeyboard.bind(this);
        this.handleKeyBoardPress = this.handleKeyBoardPress.bind(this);
        // this.handleKeyBoardBackspace = this.handleKeyBoardBackspace.bind(this);
        this.handleKeyBoardFinish = this.handleKeyBoardFinish.bind(this);

        this.handleBackspaceStart = this.handleBackspaceStart.bind(this);
        this.handleBackspaceEnd = this.handleBackspaceEnd.bind(this);

        this.handleInputClicked = this.handleInputClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handlePreventDefault = this.handlePreventDefault.bind(this);

        this.timerTick = this.timerTick.bind(this);
        this.state = {
            text: "",
            timeUntilCall: 0,
            timeUntilCallFinished: false,
            prevProps: null,
            isInvalid: false,
            showClear: false,
            isKeyBoardOpened: false,
        };
        this.timerDescriptor = null;
        this.startTimerTick = null;
        this.startTimeUntilCall = null;
        this.backspaceDescriptor = null;
    }

    getPostFix() {
        switch (this.props.handlerId) {
            case CodeSendHandlersIds.HANDLER_SMS:
                return "SMS";
            case CodeSendHandlersIds.HANDLER_GOOGLE:
                return "GOOGLE";
            case CodeSendHandlersIds.HANDLER_EMAIL:
                return "EMAIL";
            case CodeSendHandlersIds.HANDLER_WHATS_APP:
                return "WHATS_APP";
            case CodeSendHandlersIds.HANDLER_TELEGRAM:
                return "TELEGRAM";
            case CodeSendHandlersIds.HANDLER_FLASHCALL:
                return "FLASHCALL";
            case CodeSendHandlersIds.HANDLER_VOICECALL:
                return "VOICECALL";
            default:
                return "SMS";
        }
    }

    getHeaderLabel() {
        return;
    }

    getSubHeaderLabel() {
        return;
    }

    getPlaceholderLabel() {
        return Language.getLabel("L_CONFIRM_HEADER_" + this.getPostFix());
        // "Введите СМС Код"
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.text) {
            this.refs.input.refs.input.focus();
            this.setState({
                isInvalid: true,
            });
            return;
        }
        this.props.onSubmit({
            text: this.state.text,
            handlerId: this.props.handlerId,
        });
    }

    handleChange(event) {
        this.setState({
            text: event.target.value,
        });
    }

    static getDerivedStateFromProps(props, state) {
        const prevProps = state.prevProps;
        const prevState = state.prevState;

        return {
            isInvalid: (prevState && state.isInvalid) ? prevState.text === state.text : state.isInvalid,
            timeUntilCall: (!prevProps || (prevProps && (prevProps.timeUntilCallFinished !== props.timeUntilCallFinished || props.timeUntilCall !== prevProps.timeUntilCall)) && !props.timeUntilCallFinished) ? props.timeUntilCall : state.timeUntilCall,
            timeUntilCallFinished: props.timeUntilCallFinished,
            prevProps: props,
            prevState: state
        };
    }

    componentDidMount() {
        this.checkAndStartTimer();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.disableTabs !== this.props.disableTabs &&
            !!prevProps.disableTabs) {
            $(this.refs.container).find(':focus').blur();
        }
        this.checkAndStartTimer(prevProps);
    }

    checkAndStartTimer(prevProps) {
        if (!prevProps || (prevProps && (prevProps.timeUntilCallFinished !== this.props.timeUntilCallFinished || this.props.timeUntilCall !== prevProps.timeUntilCall)) && !this.props.timeUntilCallFinished) {
            this.startTimer();
        }
    }

    startTimer() {
        this.startTimerTick = Date.now();
        this.startTimeUntilCall = this.state.timeUntilCall;
        this.timerTick();
    }

    timerTick() {
        const secondsLeft = parseInt((Date.now() - this.startTimerTick) / 1000, 10);
        const newTimeUntilCall = Math.max(this.startTimeUntilCall - secondsLeft, 0);

        if (newTimeUntilCall !== 0) {
            clearTimeout(this.timerDescriptor);
            this.timerDescriptor = setTimeout(this.timerTick, TIMER_TICK_TIMEOUT);
        }
        if (this.state.timeUntilCall !== newTimeUntilCall) {
            this.setState({
                timeUntilCall: newTimeUntilCall,
            });
        }
        if (newTimeUntilCall === 0) {
            this.props.onTimerFinished();
        }
    }

    getTabIndex() {
        return this.props.disableTabs ? "-1" : "";
    }

    getPending() {
        return !!this.props.pending;
    }

    handleKeyPress(event) {
        event.preventDefault();
        return false;
    }

    handleKeyBoardOnClear() {
        this.setState({
            text: '',
        });
    }

    handleCloseKeyboard() {
        this.setState({
            isKeyBoardOpened: false,
        });
        // this.props.onKeyBoardSwitch({opened: false});
    }

    handleBackspaceStart() {
        this.backspaceDescriptor = setTimeout(() => {
            this.backspaceDescriptor = setInterval(() => {
                this.handleKeyBoardBackspace();
            }, DELETE_DELAY_TIME_INTERVAL);
        }, DELETE_DELAY_TIMEOUT);
    }

    handleBackspaceEnd() {
        clearTimeout(this.backspaceDescriptor);
        clearInterval(this.backspaceDescriptor);

        // this.refs.input.refs.input.blur();
        // this.refs.input.refs.input.focus();

        this.handleKeyBoardBackspace();
    }

    handleKeyBoardBackspace() {
        this.setState({
            text: this.state.text.slice(0, -1),
        });
    }

    handleKeyBoardFinish() {
        this.handleCloseKeyboard();
    }

    handleOpenKeyboard(event) {
        this.setState({
            isKeyBoardOpened: true,
        });
        // this.props.onKeyBoardSwitch({opened: true});
    }

    handlePreventDefault(event) {
        event.preventDefault();
        return false;
    }

    setCarriageToEnd() {
        const value = this.refs.input.refs.input.value;
        if (typeof this.refs.input.refs.input.setSelectionRange === 'function') {
            this.refs.input.refs.input.setSelectionRange(value.length, value.length);
        }
    }

    handleInputClicked() {
        this.setCarriageToEnd();
    }

    handleKeyBoardPress(event) {
        const target = event.target;
        const value = target.getAttribute("data-value");

        this.setState({
            text: this.state.text + value
        });
    }

    componentWillUnmount() {
        clearTimeout(this.timerDescriptor);
    }

    render() {
        return (
          <div className="modal-verification-new__body-sms" ref="container">
            <form className="modal-verification-new__form-sms" onSubmit={this.handleSubmit}>
              <h2
                className="modal-verification-new__title-sms text text--size-body-bold-large"
                dangerouslySetInnerHTML={{
                  __html: Language.getLabel("L_CONFIRM_HEADER_" + this.getPostFix()),
                }}
              ></h2>

              {this.props.handlerId === CodeSendHandlersIds.HANDLER_VOICECALL && (
                <div className="modal-verification-new__body-img">
                  <img src="/img/modal-confirm-flashcall.png" alt="modal-img" />
                </div>
              )}
              {this.props.handlerId === CodeSendHandlersIds.HANDLER_FLASHCALL && (
                      <div className="modal-verification-new__body-img">
                          <img src="/img/modal-confirm-flashcall.png" alt="modal-img" />
                      </div>
              )}

              {this.props.handlerId === CodeSendHandlersIds.HANDLER_EMAIL && (
                      <div className="modal-verification-new__body-img">
                          <img src="/img/modal-confirm-email.svg" alt="modal-img" />
                      </div>
              )}

              {this.props.handlerId === CodeSendHandlersIds.HANDLER_TELEGRAM && (
                      <div className="modal-verification-new__body-img">
                          <img src="/img/modal-confirm-telegram-bot.svg" alt="modal-img" />
                      </div>
              )}

              <div
                className="modal-verification-new__lead-sms text text--size-body-medium text--color-gray"
                dangerouslySetInnerHTML={{
                  __html: Language.getLabel("L_CONFIRM_SUB_HEADER_" + this.getPostFix()),
                }}
              ></div>

              <div className="modal-verification-new__content-sms">
                <InputClearifier
                  ref="input"
                  onChange={this.handleChange}
                  onFocus={this.handleOpenKeyboard}
                  onBlur={funcStub}
                  onClear={this.handleKeyBoardOnClear}
                  onTouchEnd={utils.isMobile() ? this.handleInputClicked : funcStub}
                  onMouseUp={utils.isMobile() ? funcStub : this.handleInputClicked}
                  onKeyPress={this.handleKeyPress}
                  onCut={this.handlePreventDefault}
                  onPaste={this.handlePreventDefault}
                  onCopy={this.handlePreventDefault}
                  disabled={this.getPending()}
                  placeholder={Language.getLabel("L_CONFIRM_PLACEHOLDER_" + this.getPostFix())}
                  additionalClassName={this.state.isInvalid ? "is-invalid" : ""}
                  name="text"
                  value={this.state.text}
                  tabIndex={this.getTabIndex()}
                />
                {!!this.props.isUseRecallButtons &&
                  this.props.handlerId !== CodeSendHandlersIds.HANDLER_EMAIL && (
                    <div>
                      {!this.state.timeUntilCallFinished && (
                        <div className="modal-verification-new__info-box-sms info-b-box">
                          <div className="info-b">
                            {Language.getLabel("L_REPEAT_SEND", {
                              time: this.state.timeUntilCall,
                            })}
                          </div>
                        </div>
                      )}
                      {this.state.timeUntilCallFinished && (
                        <div className="modal-verification-new__list-sms light-block">
                          <div className="modal-verification-new__group">
                            <button
                              className="btn-new btn-new--block"
                              type="button"
                              onClick={this.props.onSendSMS}
                            >
                              <svg
                                className="icon icon--sms"
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_1401_2741)">
                                  <path
                                    d="M22.5 8.25387V17.2C22.5 18.7467 21.2632 20 19.7368 20H5.26316C4.53032 20 3.8275 19.705 3.30931 19.1799C2.79112 18.6548 2.5 17.9426 2.5 17.2V8.25387L12.1832 13.6512C12.3805 13.7611 12.62 13.7611 12.8168 13.6512L22.5 8.25333V8.25387ZM19.7368 4C20.4581 4.00007 21.1508 4.28595 21.6669 4.79657C22.183 5.3072 22.4816 6.00209 22.4989 6.7328L12.5 12.3061L2.50105 6.73227L2.50211 6.68427C2.53158 5.96227 2.83537 5.27978 3.34995 4.77951C3.86453 4.27924 4.55005 3.99993 5.26316 4H19.7368Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1401_2741">
                                    <rect
                                      width="24"
                                      height="24"
                                      fill="white"
                                      transform="translate(0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              {Language.getLabel("L_SEND_SMS")}
                            </button>
                          </div>
                          <div className="modal-verification-new__group">
                            <button
                              className="btn-new btn-new--block"
                              type="button"
                              onClick={this.props.onOrderCall}
                            >
                              <svg
                                className="icon icon--call"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.89489 2.58107C4.96482 1.98434 6.32917 1.84452 7.63338 2.1741C8.26857 2.33389 8.81105 2.74461 9.13679 3.31014L10.2618 5.26513C10.6628 5.9621 10.7786 6.78631 10.5852 7.56622C10.3917 8.34614 9.90391 9.02168 9.22324 9.45225L8.23349 10.0789C7.82381 10.3374 7.67347 10.7331 7.76743 11.0464C8.10319 12.1675 8.84613 13.4109 9.66298 14.2623C9.90603 14.517 10.352 14.5769 10.788 14.3235L11.3355 14.0051C11.6948 13.7965 12.0921 13.6612 12.5044 13.6072C12.9166 13.5532 13.3356 13.5815 13.7367 13.6905C14.1379 13.7995 14.5133 13.987 14.841 14.2421C15.1686 14.4971 15.4421 14.8147 15.6453 15.1761L16.6538 16.9676C16.9833 17.5543 17.0372 18.2547 16.8042 18.8851C16.3394 20.1373 15.4436 21.1472 14.3424 21.6528C13.2236 22.1659 11.9143 22.1447 10.7292 21.357C8.85239 20.1111 6.59101 18.0138 4.54261 14.5157C2.46791 10.9703 1.94547 7.95292 2.00435 5.70331C2.04194 4.26391 2.80617 3.1878 3.89489 2.58107ZM15.411 2.10668C15.2658 2.02623 15.0945 2.00654 14.9347 2.05196C14.775 2.09738 14.6398 2.20418 14.5591 2.34887C14.4783 2.49356 14.4586 2.66429 14.5042 2.82349C14.5498 2.98269 14.6569 3.11733 14.8021 3.19778L15.2832 3.46494C16.7862 4.29688 18.0646 5.47904 19.0093 6.9104C19.954 8.34175 20.5368 9.97974 20.708 11.6844L20.7481 12.0776C20.7529 12.1618 20.7747 12.2441 20.8122 12.3197C20.8497 12.3952 20.9022 12.4624 20.9665 12.5172C21.0308 12.572 21.1056 12.6132 21.1864 12.6384C21.2671 12.6636 21.3521 12.6722 21.4363 12.6638C21.5205 12.6554 21.602 12.63 21.6761 12.5893C21.7502 12.5486 21.8152 12.4933 21.8673 12.4269C21.9194 12.3605 21.9574 12.2842 21.9791 12.2027C22.0008 12.1212 22.0057 12.0362 21.9935 11.9528L21.9546 11.5608C21.7635 9.65523 21.1121 7.82413 20.0561 6.22404C19.0001 4.62396 17.571 3.30248 15.8909 2.37259L15.411 2.10668ZM13.9427 5.45239C14.0283 5.31053 14.1669 5.20836 14.3281 5.16832C14.4892 5.12829 14.6598 5.15368 14.8021 5.23891L14.9575 5.33129C15.9688 5.93546 16.8364 6.75125 17.5002 7.72227C18.1641 8.6933 18.6084 9.7964 18.8025 10.9553L18.8576 11.2886C18.8738 11.3706 18.8734 11.455 18.8563 11.5368C18.8392 11.6186 18.8058 11.6961 18.7581 11.7648C18.7104 11.8335 18.6493 11.892 18.5785 11.9367C18.5076 11.9815 18.4285 12.0116 18.3458 12.0253C18.2631 12.039 18.1785 12.036 18.0969 12.0165C18.0154 11.9971 17.9386 11.9615 17.8711 11.9118C17.8037 11.8622 17.7469 11.7996 17.7041 11.7278C17.6614 11.6559 17.6336 11.5762 17.6223 11.4934L17.5659 11.1613C17.4021 10.1806 17.0266 9.24711 16.4653 8.42525C15.904 7.60338 15.1702 6.91277 14.3148 6.40117L14.1594 6.30879C14.0888 6.26666 14.0273 6.2111 13.9782 6.14526C13.9292 6.07942 13.8937 6.0046 13.8736 5.92507C13.8536 5.84554 13.8495 5.76286 13.8616 5.68176C13.8737 5.60065 13.9016 5.52271 13.9439 5.45239H13.9427Z"
                                  fill="white"
                                />
                              </svg>
                              {Language.getLabel("L_REQUEST_CALL")}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                <button
                  className="btn-new btn-new--block"
                  disabled={this.getPending()}
                  tabIndex={this.getTabIndex()}
                  type="submit"
                >
                  {this.props.handlerId === CodeSendHandlersIds.HANDLER_FLASHCALL ? Language.getLabel("L_NEXT") : Language.getLabel("L_SEND")}
                </button>
              </div>
              <div className="modal-verification-new__list-buttons">
                {this.props.handlerId === CodeSendHandlersIds.HANDLER_EMAIL && (
                  <div>
                    {!this.state.timeUntilCallFinished && (
                      <div className="modal-verification-new__info-box-sms info-b-box">
                        {/* <div className="info-b"> */}
                        <span className='modal-verification-new__repeat-msg'>
                          {Language.getLabel("L_REPEAT_SEND", {
                            time: this.state.timeUntilCall,
                          })}
                        </span>
                      </div>
                    )}
                    {this.state.timeUntilCallFinished && (
                      <div className="modal-verification-new__content-sms">
                        <div className="modal-verification-new__group">
                          <span className='modal-verification-new__repeat-msg' onClick={this.props.onResendEmail}>
                            {Language.getLabel("L_SEND_EMAIL_AGAIN")}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {this.props.handlerId === CodeSendHandlersIds.HANDLER_FLASHCALL && (
                      <div>
                          {!this.state.timeUntilCallFinished && (
                              <div className="modal-verification-new__info-box-sms info-b-box">
                                  <span className='modal-verification-new__repeat-msg'>
                                      {Language.getLabel("L_REPEAT_SEND", {
                                          time: this.state.timeUntilCall,
                                      })}
                                  </span>
                              </div>
                          )}
                          {this.state.timeUntilCallFinished && (
                              <div className="modal-verification-new__content-sms">
                                  <div className="modal-verification-new__group">
                                      <span
                                          className='modal-verification-new__repeat-msg'
                                          onClick={this.props.onSendFlashcallCode}
                                      >
                                          {Language.getLabel("L_CALL_ME_ONCE_MORE")}
                                      </span>
                                  </div>
                              </div>
                          )}
                      </div>
                  )}

                  {this.props.handlerId === CodeSendHandlersIds.HANDLER_VOICECALL && (
                      <div>
                          {!this.state.timeUntilCallFinished && (
                              <div className="modal-verification-new__info-box-sms info-b-box">
                                  <span className='modal-verification-new__repeat-msg'>
                                      {Language.getLabel("L_REPEAT_SEND", {
                                          time: this.state.timeUntilCall,
                                      })}
                                  </span>
                              </div>
                          )}
                          {this.state.timeUntilCallFinished && (
                              <div className="modal-verification-new__content-sms">
                                  <div className="modal-verification-new__group">
                                      <span
                                          className='modal-verification-new__repeat-msg'
                                          onClick={this.props.onSendVoicecallCode}
                                      >
                                          {Language.getLabel("L_CALL_ME_ONCE_MORE")}
                                      </span>
                                  </div>
                              </div>
                          )}
                      </div>
                  )}
              </div>

              <div className="modal-verification-new__number-keyboard-pin 
              modal-verification-new__number-keyboard-pin-only-mobile number-keyboard">
                <div className="number-keyboard__row">
                  <button
                    className="number-keyboard__cell"
                    tabIndex={this.getTabIndex()}
                    disabled={this.getPending()}
                    data-value="1"
                    onClick={this.handleKeyBoardPress}
                    type="button"
                  >
                    1
                  </button>
                  <button
                    className="number-keyboard__cell"
                    tabIndex={this.getTabIndex()}
                    disabled={this.getPending()}
                    data-value="2"
                    onClick={this.handleKeyBoardPress}
                    type="button"
                  >
                    2
                  </button>
                  <button
                    tabIndex={this.getTabIndex()}
                    disabled={this.getPending()}
                    className="number-keyboard__cell"
                    data-value="3"
                    onClick={this.handleKeyBoardPress}
                    type="button"
                  >
                    3
                  </button>
                </div>
                <div className="number-keyboard__row">
                  <button
                    tabIndex={this.getTabIndex()}
                    disabled={this.getPending()}
                    className="number-keyboard__cell"
                    data-value="4"
                    onClick={this.handleKeyBoardPress}
                    type="button"
                  >
                    4
                  </button>
                  <button
                    tabIndex={this.getTabIndex()}
                    disabled={this.getPending()}
                    className="number-keyboard__cell"
                    data-value="5"
                    onClick={this.handleKeyBoardPress}
                    type="button"
                  >
                    5
                  </button>
                  <button
                    tabIndex={this.getTabIndex()}
                    disabled={this.getPending()}
                    className="number-keyboard__cell"
                    data-value="6"
                    onClick={this.handleKeyBoardPress}
                    type="button"
                  >
                    6
                  </button>
                </div>
                <div className="number-keyboard__row">
                  <button
                    className="number-keyboard__cell"
                    data-value="7"
                    onClick={this.handleKeyBoardPress}
                    disabled={this.getPending()}
                    type="button"
                    tabIndex={this.getTabIndex()}
                  >
                    7
                  </button>
                  <button
                    className="number-keyboard__cell"
                    data-value="8"
                    onClick={this.handleKeyBoardPress}
                    disabled={this.getPending()}
                    type="button"
                    tabIndex={this.getTabIndex()}
                  >
                    8
                  </button>
                  <button
                    className="number-keyboard__cell"
                    data-value="9"
                    onClick={this.handleKeyBoardPress}
                    disabled={this.getPending()}
                    type="button"
                    tabIndex={this.getTabIndex()}
                  >
                    9
                  </button>
                </div>
                <div className="number-keyboard__row">
                  <button
                    className="number-keyboard__cell number-keyboard__cell--error"
                    onMouseDown={utils.isMobile() ? funcStub : this.handleBackspaceStart}
                    onMouseUp={utils.isMobile() ? funcStub : this.handleBackspaceEnd}
                    onTouchStart={utils.isMobile() ? this.handleBackspaceStart : funcStub}
                    onTouchEnd={utils.isMobile() ? this.handleBackspaceEnd : funcStub}
                    type="button"
                    disabled={this.getPending()}
                    tabIndex={this.getTabIndex()}
                  >
                    <svg
                      className="icon icon--delete-pin"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.67079 16L10.417 9.5H27.5002V22.5H10.417L4.67079 16ZM9.44249 8.33767C9.6323 8.12296 9.90511 8 10.1917 8H28.0002C28.5525 8 29.0002 8.44772 29.0002 9V23C29.0002 23.5523 28.5525 24 28.0002 24H10.1917C9.90511 24 9.6323 23.877 9.44248 23.6623L3.25421 16.6623C2.91982 16.2841 2.91982 15.7159 3.25421 15.3377L9.44249 8.33767ZM13.9812 19C13.771 19.2079 13.771 19.545 13.9812 19.7529L14.0734 19.8441C14.2836 20.052 14.6244 20.052 14.8345 19.8441L17.86 16.8513L20.8854 19.8441C21.0956 20.052 21.4364 20.052 21.6465 19.8441L21.7387 19.7529C21.9489 19.545 21.9489 19.2079 21.7387 19L18.7133 16.0072L21.7533 13C21.9635 12.7921 21.9635 12.455 21.7533 12.2471L21.6611 12.1559C21.451 11.948 21.1102 11.948 20.9 12.1559L17.86 15.1631L14.8199 12.1559C14.6097 11.948 14.269 11.948 14.0588 12.1559L13.9666 12.2471C13.7564 12.455 13.7564 12.7921 13.9666 13L17.0066 16.0072L13.9812 19Z"
                      />
                    </svg>
                  </button>
                  <button
                    className="number-keyboard__cell"
                    data-value="0"
                    onClick={this.handleKeyBoardPress}
                    type="button"
                    disabled={this.getPending()}
                    tabIndex={this.getTabIndex()}
                  >
                    0
                  </button>
                  <button
                    className="number-keyboard__cell number-keyboard__cell--succes"
                    type="submit"
                    disabled={this.getPending()}
                    tabIndex={this.getTabIndex()}
                  >
                    <svg
                      className="icon icon--succes-pin"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M25.4 16C25.4 21.1915 21.1915 25.4 16 25.4C10.8085 25.4 6.6 21.1915 6.6 16C6.6 10.8085 10.8085 6.6 16 6.6C21.1915 6.6 25.4 10.8085 25.4 16ZM27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM10 16.4999L14.0003 20L14.0011 19.9993L15.143 19.0002L22 12.9998L20.8573 12L14.0015 17.9986L11.1427 15.5001L10 16.4999Z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </form>
          </div>
        );
    }
}

export default ModalTextForm;